import { combineReducers } from "redux";
import druggistReducer from "./druggistReducer";
import userReducer from "./userReducer";

export default combineReducers({
  user: userReducer,
  druggist: druggistReducer,
});
